module.exports = __webpack_public_path__ + "img/45.07b03804.png";